import React from 'react';
import './style/Button.scss';

export default ({
    disabled = false,
    type = '',
    size = 'medium',
    onClick = () => {},
    text = '',
    ...rest
    }) => {

    const handleOnClick = (event) => {
        if (onClick) {
            onClick(event);
        }
    };

    return (
        <button
            className = {`button ${type} ${size}`}
            onClick = {handleOnClick}
            disabled = {disabled}
            data-testid = 'button'
            { ...rest }
            type = 'button'>
            {text}
        </button>
    );
};